'use client'

import React from 'react';

const tips = [
  { id: 1, title: "Always use stop loss", desc: "Protect your capital from unexpected market volatility.", icon: "🛡️" },
  { id: 2, title: "Risk Management", desc: "Only trade with capital you can afford to lose.", icon: "📊" },
  { id: 3, title: "Emotional Discipline", desc: "Decide wisely and never let fear or greed drive trades.", icon: "🧠" },
  { id: 4, title: "Thorough Research", desc: "Deep dive into fundamentals before committing funds.", icon: "🔍" },
  { id: 5, title: "Capital Allocation", desc: "Avoid putting all your eggs in a single basket.", icon: "⚖️" },
  { id: 6, title: "Curb Greed", desc: "Stick to your targets and exit when your plan is met.", icon: "🚫" }
];

export default function DoDont() {
  return (
    <div className="min-h-screen bg-white text-gray-700 py-16 px-4 sm:px-8 md:px-16 lg:px-24">
      
      {/* Background Accents */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[20%] left-[10%] w-[30%] h-[30%] rounded-full bg-indigo-600/10 blur-[120px]" />
        <div className="absolute bottom-[10%] right-[10%] w-[25%] h-[25%] rounded-full bg-blue-600/10 blur-[100px]" />
      </div>

      <div className="relative z-10 w-full">
        {/* Header Section */}
        <header className="mb-16 text-left">
          <div className="inline-block px-3 py-1 mb-4 rounded-full border border-indigo-500/30 bg-indigo-500/10 text-indigo-400 text-xs font-bold uppercase tracking-widest">
            Pro Trader Guidelines
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 tracking-tighter mb-6">
            The Golden Rules <br /> of Investing
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl leading-relaxed">
            Success in the markets isn't just about the right calls—it's about the right habits. 
            Follow these core principles to safeguard your portfolio.
          </p>
        </header>

        {/* Responsive Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {tips.map((tip) => (
            <div 
              key={tip.id} 
              className="group relative p-8 rounded-[2rem] bg-gray-50 border border-gray-200 overflow-hidden transition-all duration-500 hover:bg-white hover:-translate-y-2 hover:shadow-xl hover:shadow-[#1e6091]/10 hover:border-[#1e6091]/30"
            >
              {/* Hover Gradient Background */}
              <div className="absolute inset-0 bg-gradient-to-br from-indigo-600/0 via-transparent to-blue-600/0 group-hover:from-indigo-600/5 group-hover:to-blue-600/5 transition-colors duration-500" />
              
              {/* Corner Accent */}
              <div className="absolute top-0 right-0 p-6 opacity-20 group-hover:opacity-100 transition-opacity duration-500 text-4xl">
                {tip.icon}
              </div>

              <div className="relative z-10">
                {/* Number Badge */}
                <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-indigo-500/15 border border-indigo-500/30 text-indigo-600 font-bold mb-6 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-300">
                  {tip.id}
                </div>

                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 tracking-tight group-hover:text-indigo-700 transition-colors">
                  {tip.title}
                </h2>
                
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                  {tip.desc}
                </p>
              </div>

              {/* Bottom Decorative Line */}
              <div className="absolute bottom-0 left-0 h-[2px] w-0 bg-gradient-to-r from-indigo-500 to-cyan-500 group-hover:w-full transition-all duration-700 ease-out" />
            </div>
          ))}
        </div>

        {/* Final Motto */}
        <div className="mt-20 p-10 rounded-3xl border border-dashed border-gray-300 text-center">
            <p className="text-gray-500 uppercase tracking-[0.3em] text-xs font-bold">
              Trade with Logic • Profit with Patience
            </p>
        </div>
      </div>
    </div>
  );
}